var render = function render(){var _vm=this,_c=_vm._self._c;return _c('IconVideo',{staticClass:"message-input-tool icon-small icon-grey",nativeOn:{"click":function($event){return _vm.showVideoConferencingModal.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }